import {formValues} from '@ttx/design-system';
import {usePlausible} from 'next-plausible';
import {useToastContext} from '../contexts/toast-context';
import {useTtxMutation} from './ttx-trpc';

export const useEmailSignup: ({
  collectionId,
  artistSlug,
}: {
  collectionId?: string;
  artistSlug: string;
}) => {
  onSignupSubmit: (values: formValues) => void;
} = ({collectionId, artistSlug}) => {
  const toast = useToastContext();
  const plausible = usePlausible();

  const {...interestAudience} = useTtxMutation(
    'data-capture.interest-audience',
  );

  // eslint-disable-next-line consistent-return
  const onSignupSubmit = async (values: formValues) => {
    if (!collectionId)
      return toast.addErrorToast('Error signing up. Try again later.');
    interestAudience.mutate(
      {
        name: values.name,
        email: values.email,
        collectionId,
        phone: undefined,
        recaptcha: values.recaptcha,
      },
      {
        onSuccess: async () => {
          plausible('Email Signup Successful', {
            props: {artist: artistSlug},
          });
          toast.addSuccessToast(`You've successfully signed up.`);
        },
        onError: async () => {
          toast.addErrorToast('Error signing up. Try again later.');
        },
      },
    );
  };

  return {onSignupSubmit};
};
